import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
import { AvatarComponent } from '@rma/dashboard/generic/ui/avatar';

const TRANSLATION_SCOPE = 'accountActions';

@Component({
  selector: 'rma-switch-profile-overlay',
  imports: [AvatarComponent, TranslocoDirective],
  providers: [provideTranslocoScope(TRANSLATION_SCOPE)],
  templateUrl: './switch-profile-overlay.component.html',
  styles: `
    .switch-profile-overlay .mat-mdc-dialog-surface {
      --mat-dialog-container-color: transparent;
      --mat-dialog-container-elevation-shadow: none;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SwitchProfileOverlayComponent {
  public readonly profile = inject<{ name: string; image: string }>(MAT_DIALOG_DATA);
  public readonly scope = TRANSLATION_SCOPE;
}
